"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = theme => ({
    root: {
        height: constants_1.MIN_TARGET_SIZE,
        borderRadius: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        overflow: 'hidden',
        boxSizing: 'border-box',
        borderWidth: 1,
        borderStyle: 'solid',
        appearance: 'none',
        flexShrink: 0,
        cursor: 'default',
        outline: 'none',
        paddingLeft: 14,
        paddingRight: 14,
        boxShadow: `0 0 0 0 ${theme.indigoPastel2}`,
        transition: `box-shadow 150ms linear, background-color 150ms linear, border-color 150ms linear`,
        color: theme.grey2,
        borderColor: 'currentColor',
        backgroundColor: 'transparent',
        '&:not([disabled]):hover': {
            color: theme.grey1,
            cursor: 'pointer'
        },
        '&[disabled]': {
            opacity: 0.3
        },
        '&:focus, &[aria-expanded=true]': {
            boxShadow: `0 0 0 ${constants_1.FOCUS_OUTLINE_WIDTH}px ${theme.indigoPastel2}`
        },
        '&[data-is-primary="true"]': {
            color: theme.white1,
            borderColor: theme.indigo3,
            backgroundColor: theme.indigo3,
            '&:not([disabled]):hover': {
                color: theme.white1,
                backgroundColor: theme.indigo2,
                borderColor: theme.indigo2
            }
        },
        '&[data-is-secondary="true"]': {
            color: theme.indigo3,
            '&:not([disabled]):hover': {
                color: theme.indigo2
            }
        },
        '&[data-is-warning="true"]': {
            color: theme.warningRed,
            borderColor: theme.warningRed,
            '&:not([disabled]):hover': {
                backgroundColor: theme.warningRed,
                color: theme.white1
            }
        }
    },
    text: {
        flexGrow: 1,
        color: 'currentColor',
        lineHeight: `${constants_1.MIN_TARGET_SIZE - 2}px`,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 1,
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
    },
    icon: {
        flexShrink: 0,
        marginLeft: 14,
        color: 'currentColor'
    }
});
//# sourceMappingURL=pulldown.button.style.js.map